// rebuy购物车弹窗，ga4埋点
document.addEventListener('DOMContentLoaded', function () {
  // 调试日志
  // console.log('Rebuy event listeners initialized');

  // 存储之前的购物车数据
  let cartItems = {
    detail: {
      cart: {
        cart: {
          items: []
        }
      }
    }
  };
  let currency = ''

  // 监听购物车弹窗可见性
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.target.id === 'rebuy-cart') {
          const isVisible = mutation?.target?.classList.contains('is-visible');
  
          if (isVisible && window.Rebuy.Cart) {
  
            const cart = window.Rebuy.Cart.cart;     
  
            // 触发曝光事件
            // console.log('=====ga--push--view_cart--',cart );
            
            try {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ "event_parameters": null });
              window.dataLayer.push({
                "event": "ga4Event",
                "event_name": "view_cart",
                "event_parameters": {
                  "currency": cart.currency,
                  "value": Number(cart.total_price / 100),
                  "item_list_id": "",
                  "item_list_name": "Rebuy Cart",
                  "items": cart.items.map((item, index) => ({
                    "item_id": item.sku || item.product_id,
                    "item_name": item.product_title,
                    "discount": Number((item.compare_at_price - item.final_price) / 100),
                    "index": index + 1,
                    "item_list_id": "",
                    "item_list_name": "Cart",
                    "item_category": item.product_id,
                    "item_category2": item.variant_options[0] || '',
                    "item_category3": item.variant_options[1] || '',
                    "item_brand": "Laifen",
                    "item_variant": item.product_type,
                    "price": Number(item.final_price / 100),
                    "quantity": Number(item.quantity),
                    "currency": cart.currency
                  }))
                }
              });
            } catch (error) {
              console.log('=====ga==error', error);
            }
            
          } else if (!isVisible) {
          }
        }
    });
  });

  // 防抖动函数, Rebuy会触发两次
  function debounce(func, wait = 500) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  const pushDataLayer = function (event_name, item) {
    try {
      window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event": "ga4Event",
      "event_name": event_name,
      "event_parameters": {
        "currency": currency,
        "value": Number(item.final_line_price_changed / 100),
        "item_list_id": "",
        "item_list_name": "Rebuy Cart",
        "items": [
          {
            "item_id": item.sku || item.product_id,
            "item_name": item.product_title,
            "discount": Number((item.original_price - item.final_price) / 100),
            "index": item.line_index,
            "item_list_id": "",
            "item_list_name": "Cart",
            "item_category": item.product_id,
            "item_category2": item.variant_options[0] || '',
            "item_category3": item.variant_options[1] || '',
            "item_brand": "Laifen",
            "item_variant": item.product_type,
            "price": Number(item.final_price / 100),
            "quantity": Number(item.quantity_changed),
            "currency": currency
          }
        ]
      }
    });
    } catch (error) {
      console.log('====ga=eree',error);
      
    }
  }
  const handleReadyCartEvent = debounce(function (event) {
    console.log('rebuy:cart.ready ===== ga', event);
    if (event.detail && event.detail.cart && event.detail.cart.cart) {
      currency = event.detail.cart.cart.currency
      cartItems = event.detail.cart.cart;
      // 开始观察购物车弹窗
      const cartElement = document.getElementById('rebuy-cart');
      // console.log('cartElement', cartElement);

      if (cartElement) {
        observer.observe(cartElement, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      //
      const checkOutBtn = document.querySelector(".rebuy-cart__checkout-button")
      checkOutBtn.addEventListener('click', () => {
        const cart = window.Rebuy.Cart.cart;
        // console.log(cart,'=====')
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
          "event":"ga4Event",
          "event_name":"checkout",
          "event_parameters":{
            "button_name": "Checkout",
            "product_name":cart.items.map((item) => (item.product_title)).join(',')
          }
        });
      })
    }
  }, 500)

  const handleChangeCartEvent = debounce(function (event) {
    console.log('rebuy:cart.change=====ga', event);

    try {
      let currentCartItems = event.detail.cart.cart
      // console.log('====ga=currenCartItems', currentCartItems,cartItems);
      // console.log('====ga=currenCartItems', currentCartItems.item_count,cartItems.item_count);

      // console.log(previousCartTotal, total);
      const cartElement = document.getElementById('rebuy-cart');
      const isVisible = cartElement?.classList.contains('is-visible');

      setTimeout(function () {
        if(!isVisible) return
        let event_name = '';
        if (currentCartItems.item_count > cartItems.item_count) {
          event_name = 'add_to_cart';
          const addedItems = currentCartItems.items?.filter((current, index) => {
            current.line_index = index + 1;
            const prevItem = cartItems.items.find(prev => prev.variant_id === current.variant_id);
            if (!prevItem) {
              // 新增商品，记录完整数量
              current.quantity_changed = current.quantity;
              current.final_line_price_changed = current.quantity_changed * current.price;
              return true;
            } else if (current.quantity > prevItem.quantity) {
              // 数量增加，记录增加的数量
              current.quantity_changed = current.quantity - prevItem.quantity;
              current.final_line_price_changed = current.quantity_changed * current.price;
              return true;
            }
            return !prevItem || current.quantity > prevItem.quantity;
          });
          // 找出添加的商品
          
          // console.log('====ga==addedItems', JSON.parse(JSON.stringify(addedItems)))
          pushDataLayer(event_name, addedItems[0]);
        } else if (currentCartItems.item_count < cartItems.item_count) {
          event_name = 'remove_from_cart';
          if (currentCartItems.items.length < cartItems.items.length) {
            // 找出完全删除的商品
            const removedItems = cartItems.items.filter((prev,index) => {
              prev.line_index = index + 1;
              
              const isRemoved = !currentCartItems.items?.some(current => current && (current?.variant_id === prev.variant_id));
              if (isRemoved) {
                prev.quantity_changed = prev.quantity; // 记录删除的完整数量
                prev.final_line_price_changed = prev.quantity_changed * prev.price;
              }
              return isRemoved;
            });
            // console.log('====ga===removedItems完全删除', JSON.parse(JSON.stringify(removedItems)))
            pushDataLayer(event_name, removedItems[0]);
          } else {
            // 找出数量减少的商品
            const removedItems = cartItems.items.filter((prev,index) => {
              prev.line_index = index + 1;
              const currentItem = currentCartItems.items.find(current => current.variant_id === prev.variant_id);
              if (currentItem && currentItem.quantity < prev.quantity) {
                prev.quantity_changed = prev.quantity - currentItem.quantity; // 记录减少的数量
                prev.final_line_price_changed = prev.quantity_changed * prev.price;
                return true;
              }
              return false;
            });
            // console.log('====ga===removedItems数量减少', JSON.parse(JSON.stringify(removedItems)))
            pushDataLayer(event_name, removedItems[0]);
          }
        }
        // console.log('====ga==event_name', event_name)
        setTimeout(() => {
          cartItems = currentCartItems
        }, 500);
      },500)
    } catch (error) {
      console.log('=====ga==error', error);
    }
  }, 500)

  document.addEventListener('rebuy:cart.ready', handleReadyCartEvent);
  document.addEventListener('rebuy:cart.change', handleChangeCartEvent);

  // add to cart 按钮添加埋点

  // const addToCartBtnElement = document.getElementById('AddToCart');
  const addToCartStickyBtnElement = document.getElementById('AddToCartSticky');

  const handleAddToCartEvent = function (event) {
    const cart = window.Rebuy.Cart.cart;
    // 触发曝光事件
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event": "ga4Event",
      "event_name": "add_to_cart",
      "button_name": "Add to cart",
      "event_parameters": {
        "currency": currency,
        "value": Number(cart.total_price / 100),
        "item_list_id": "Cart",
        "item_list_name": "Cart",
        "items": cart.items.map((item, index) => ({
          "item_id": item.sku || item.product_id,
          "item_name": item.product_title,
          "discount": Number((item.original_price - item.final_price) / 100),
          "index": index + 1,
          "item_list_id": "rebuy_cart_" + item.product_id,
          "item_list_name": "Cart",
          "item_category": item.product_id,
          "item_category2": item.variant_title,
          "item_brand": "Laifen",
          "item_variant": item.product_type,
          "price": Number(item.final_price / 100),
          "quantity": item.final_line_price_changed,
          "currency": currency
        }))
      }
    });
  }

  
  // addToCartBtnElement?.addEventListener('click', handleAddToCartEvent);
  addToCartStickyBtnElement?.addEventListener('click', handleAddToCartEvent);
});
